import { render } from "./accordionArrow.vue?vue&type=template&id=3fcce799"
import script from "./accordionArrow.vue?vue&type=script&lang=js"
export * from "./accordionArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__